<template>
    <div class="section"> <!--v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"-->
      <div class="container">
<!--        <h3 class="title text-default title-up">{{viewTitle}}</h3>-->
        <slot name="scrollContentNav-mainContent"></slot>
      </div>
    </div>
</template>

<script>
export default {
  name: 'scrollContent',
  props: {
    viewTitle: {
      type: String,
      default: ''
    }
  },/*
  data: () => ({
    intersectionOptions: {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
    } // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  }),
  methods: {
    onWaypoint ({ el, going, direction, _entry }) {
      // going: in, out
      // direction: top, right, bottom, left

      var activeDIV = el.attributes.id.value;

      if (going === this.$waypointMap.GOING_IN) {
        //console.log('waypoint going in!')
      }

      if (direction === this.$waypointMap.DIRECTION_TOP) {
        //console.log('waypoint going top!')
        this.$store.commit('setActiveContentDIV', activeDIV);
      }
      //console.log(going)
      //console.log(direction)
      //console.log(this.$store.state.activeContentDIV);
      //console.log(this.$store.dispatch('state/getActiveContentDIV'));
    }
  },*/
  mounted() {

  }
};
</script>
